import CountUp from "./CountUp";

const STAT_BASE_DURATION_MS = 1400;
const STAT_STAGGER_MS = 200;

const STATS = [
  { num: 47, suffix: "", label: "Field notes shipped" },
  { num: 2400, suffix: "+", label: "Quiet readers" },
  { num: 9, suffix: " min", label: "Average read" },
  { num: 0, suffix: "", label: "Filler words" },
];

export default function StatsStrip() {
  return (
    <section
      data-testid="stats-strip"
      className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto py-16 md:py-20 relative z-10"
    >
      <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 md:gap-x-10">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`stat-${i}`}
            className="flex flex-col gap-2 border-l border-subtle pl-5 md:pl-7"
          >
            <CountUp
              target={s.num}
              suffix={s.suffix}
              duration={STAT_BASE_DURATION_MS + i * STAT_STAGGER_MS}
              className="stat-num text-4xl md:text-6xl"
            />
            <span className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.22em] text-tertiary">
              {s.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
